import { useDispatch, useSelector } from 'react-redux';
import {
  ongoingMonitoringTableView,
  initialScreeningTableView,
  setInitialPageIndexInitialScreening,
  setInitialPageSizeInitialScreening,
  resetInitialPageSizeInitialScreening,
  resetInitialPageIndexInitialScreening,
  setInitialPageIndexOngoingMonitoring,
  setInitialPageSizeOngoingMonitoring,
  resetInitialPageSizeOngoingMonitoring,
  resetInitialPageIndexOngoingMonitoring,
  setDownloadReportFilters,
  setHistoryFilters,
  setDownloadStatusFilters,
  setRiskRatingDashboardFilters,
  setExclusionListFilter,
  setAddToExclusionListFilter,
  setDashboardFilters,
  setInitialMyqueue,
  setInitialCommon,
  setOngoingCommon,
  setOngoingMyqueue,
  setInitialScreeningModule,
  setOngoingMonitoringModule,
  setCommonOngoingMonitoringModule,
  setCommonInitialScreeningModule,
  resetCommonState,
  setAssignScreeningModule,
  setAssignSingleColumn,
  setAssignBulkColumn,
  setAssignTransactionSingleColumn,
} from '../state/slices/commonSlice';

export default function useCommonReducer() {
  const dispatch = useDispatch();
  // @ts-ignore
  const { common } = useSelector((state) => state);
  return {
    dispatch,
    common,
    ongoingMonitoringTableView,
    initialScreeningTableView,
    setInitialPageIndexInitialScreening,
    setInitialPageSizeInitialScreening,
    resetInitialPageSizeInitialScreening,
    resetInitialPageIndexInitialScreening,
    setInitialPageIndexOngoingMonitoring,
    setInitialPageSizeOngoingMonitoring,
    resetInitialPageSizeOngoingMonitoring,
    resetInitialPageIndexOngoingMonitoring,
    setDownloadReportFilters,
    setHistoryFilters,
    setDownloadStatusFilters,
    setRiskRatingDashboardFilters,
    setExclusionListFilter,
    setAddToExclusionListFilter,
    setDashboardFilters,
    setInitialMyqueue,
    setInitialCommon,
    setOngoingCommon,
    setOngoingMyqueue,
    setInitialScreeningModule,
    setOngoingMonitoringModule,
    setCommonOngoingMonitoringModule,
    setCommonInitialScreeningModule,
    resetCommonState,
    setAssignScreeningModule,
    setAssignSingleColumn,
    setAssignBulkColumn,
    setAssignTransactionSingleColumn,
  };
}
